module.exports = __webpack_public_path__ + "img/1.81c94d98.png";